import React from 'react';

import { EchoNavigate, EchoSlot, type EchoSnapshot, useEcho, useEchoSnapshot } from '@betterment/shared-components';
import { Box, Flash } from '@betterment/style-closet-react';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';

import { Notifications } from '../notifications/Notifications';
import { WithLayout } from '../RetailApp/components/WithLayout';
import FullPageLoader from '../Shared/components/FullPageLoader';

function PerformanceRealtimeLoaderContent({ snapshot }: { snapshot: EchoSnapshot }) {
  const { echo, isPreview, onSubmit } = useEcho(snapshot);

  // Don't render previews, since revalidation causes the chart animation to replay.
  if (isPreview) {
    return <FullPageLoader />;
  }

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />;
}

const PerformanceRealtimeLoaderApp: React.FC = () => {
  const [searchParams] = useSearchParams();
  const url = `/app/performance_realtime?${searchParams.toString()}`;
  const snapshot = useEchoSnapshot(url);

  return (
    <WithLayout parts={{ sidebar: true, footer: true }}>
      <Helmet>
        <title>Performance | Betterment</title>
      </Helmet>

      <Notifications />

      <section className="sc-SectionLayout u-backgroundColor-bmtWhite">
        <div className="sc-SectionLayout-contentWrapper">
          <h1>Performance</h1>
        </div>
      </section>

      <section className="sc-SectionLayout sc-p-h--0 sc-p-h-md--m ft-performanceCards">
        <div className="sc-SectionLayout-contentWrapper">
          {snapshot.state === 'loading' && <FullPageLoader />}
          {snapshot.state === 'hasData' && <PerformanceRealtimeLoaderContent snapshot={snapshot.data} />}
          {snapshot.state === 'hasError' && (
            <Box className="bmt-h_90vh">
              <Flash variant="error">
                An error occurred loading your performance data. Please try again later or reach out to support for
                assistance.
              </Flash>
            </Box>
          )}
        </div>
      </section>
    </WithLayout>
  );
};

export default PerformanceRealtimeLoaderApp;
